import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions, Response} from '@angular/http';

import {Account_report} from './account_report';
import {TreeNode} from "primeng/api";

@Injectable()
export class AccountReportService {

  constructor(private http: Http) {

  }

  getAll(page: number = 1, sort: string = '') {
    let currentfilter = JSON.parse(localStorage.getItem('filter'));
    if (!currentfilter) {
      currentfilter = {};
    }

    const params = new URLSearchParams();
    params.set('page', page + '');
    params.set('sorts', sort);
    for (let key in currentfilter) {
      if (currentfilter[key]) {
        params.set('filter[' + key + ']', currentfilter[key])
      }
    }
    return this.http.get('account_report?' + params.toString()).map((response: Response) => response.json());
  }

  getByData(account_no='',cost_center_id='',fromdate='',todate='') {
    let currentfilter = JSON.parse(localStorage.getItem('filter'));
    if (!currentfilter) {
      currentfilter = {};
    }

    const params = new URLSearchParams();
    if (account_no !== '') {
      params.set('filter[account_no]', account_no);
    }
    if (cost_center_id !== '') {
      params.set('filter[cost_center_id]', cost_center_id);
    }

    params.set('filter[from_date]', fromdate);
    params.set('filter[to_date]', todate);

    return this.http.get('account_report?' + params.toString()).map((response: Response) => response.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/views/fin/account_report/account_report.service.ts